/* eslint-disable vue/require-v-for-key */
/* eslint-disable vue/require-default-prop */
 <template>
  <div>
    <b-form>
      <div class="row">
        <div class="col-md-4">
          <b-form-group label="Nome:" label-for="input-1">
            <b-form-input
              v-model="estado.nome"
              type="text"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Sigla:" label-for="input-1">
            <b-form-input
              v-model="estado.sigla"
              type="text"
              required
              max="2"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <b-button type="submit" variant="success" @click.prevent="salvar"
        >Salvar</b-button
      >
    </b-form>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </div>
</template>
<script>
import Service from '@src/services/estados-register'
import { mask } from 'vue-the-mask'
import Loading from 'vue-loading-overlay'

export default {
  components: {
    Loading,
  },
  directives: { mask },
  props: {
    estado: {},
  },
  data() {
    return {
      modal: {
        show: false,
        mensagems: null,
        sucesso: null,
      },
      isLoading: false,
    }
  },
  created() {},
  mounted() {},
  methods: {
    loading(a) {
      a = !this.isLoading
      return a
    },
    modalShow() {
      if (this.modal.show === true) {
        this.modal.show = false
      }
    },
    salvar() {
      const token = this.$store.state.auth.currentUser.token
      if (this.estado.id_estado) {
        this.isLoading = this.loading(this.isLoading)
        Service.update(token, this.estado)
          .then((resposta) => {
            this.modal.show = true
            this.$bvToast.toast('Atualizado com sucesso', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.modal.mensagems = resposta.data.aviso
            this.isLoading = this.loading(this.isLoading)
          })
          .catch((erro) => {
            this.$bvToast.toast(erro.response.data.message.join(', '), {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.isLoading = this.loading(false)
          })
      } else {
        this.isLoading = this.loading(this.isLoading)
        Service.salvar(token, this.estado)
          .then((resposta) => {
            this.isLoading = this.loading(this.isLoading)
            if (!resposta.data.sucesso) {
              this.$bvToast.toast(resposta.data.mensagem, {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            } else {
              this.$bvToast.toast('Salvo com sucesso!', {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            }
            this.estado = {}
          })
          .catch((erro) => {
            console.log(erro)
            this.isLoading = this.loading(this.isLoading)
            this.$bvToast.toast(
              erro.response ? erro.response.data.mensagem : 'Erro inesperado',
              {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              }
            )
            this.isLoading = this.loading(false)
          })
      }
    },
  },
}
</script>

<style>
</style>